import { ClubUser } from "../models/clubUser"

const location = window.location

export const getClubIdByPathname = () => Number(location.pathname.split('/')[2])
export const getClubNameByPathname = () => location.pathname.split('/')[3]

export const navigateToClub = (name, id, path = '') => {
  return `/club/${id}/${name}` + path
}

export const getFormattedClubName = () => {
  return decodeURIComponent(location.pathname.split('/')[3])
}

const scores = {
  isCreator: 10,
  isMediator: 5,
  wasAccepted: 3,
  notAccepted: -1,
  outClub: -5,
  isKickedOut: -10,
};

const getMemberScore = (member: ClubUser) => {
  let score = 0;

  // Object.keys(member).map(attr => {
  //   if (attr in scores && !!scores[attr]) {
  //     score += scores[attr];
  //   }
  // })

  if (member.isCreator) {
    score += scores.isCreator;
  }

  if (member.isMediator) {
    score += scores.isMediator;
  }

  if (member.wasAccepted) {
    score += scores.wasAccepted;
  } else {
    score += scores.notAccepted;
  }

  if (member.outClub) {
    score += scores.outClub;
  }

  if (member.isKickedOut) {
    score += scores.isKickedOut;
  }

  return score;
};

export function sortMembersByCriteria(members: ClubUser[]) {
  return members.sort((a, b) => {
    const scoreA = getMemberScore(a);
    const scoreB = getMemberScore(b);

    return scoreB - scoreA;
  })
}

export function sortMembersByCriteria1(members: ClubUser[]) {
  members.sort((a, b) => {
    // Prioritize members who are creators or mediators
    if (a.isCreator || a.isMediator) {
      return -1;
    }
    if (b.isCreator || b.isMediator) {
      return 1;
    }

    // Prioritize members who have been accepted
    if (a.wasAccepted && !b.wasAccepted) {
      return -1;
    }
    if (!a.wasAccepted && b.wasAccepted) {
      return 1;
    }

    // Prioritize members who have not been rejected or kicked
    if (!a.wasAccepted && !b.wasAccepted) {
      return 0;
    }

    // Prioritize members who are still active
    if (!a.outClub && b.outClub) {
      return -1;
    }

    if (a.outClub && !b.outClub) {
      return 1;
    }

    // Prioritize members who were not kicked
    if (!a.isKickedOut && b.isKickedOut) {
      return -1;
    }
    if (a.isKickedOut && !b.isKickedOut) {
      return 1;
    }

    // All criteria are equal, sort id
    return a.id - b.id;
  });

  return members;
}